// ─────────────────────────────
// Constants
// ─────────────────────────────

import { Activity, Award, Home, ShoppingBag, UsersIcon } from "lucide-react";

export const NAV_LINKS = [
  {
    label: "الرئيسية",
    to: "/",
    icon: Home,
  },
  {
    label: "المتجر",
    to: "/shop",
    icon: ShoppingBag,
  },
  {
    label: "من نحن",
    to: "/about",
    icon: UsersIcon, // Better than "Info" — emphasizes the team/people behind the brand
  },
  {
    label: "Ws Winner - خبراء تغذية",
    to: "/certification-details",
    icon: Award, // Perfect for expert credentials, degrees, and certificates
  },
  // {
  //   label: "تقييم اللياقة",
  //   to: "/fitness-assessment",
  //   icon: Activity,
  // },
  // { label: "صمم استراتيجيتك الغذائية - مجانا", to: "/strategy-chat" },
  //  to: "/strategy-chat",
  //     label: {
  //       ar: "تحدث معنا لتصميم استراتيجيتك الغذائية - مجاناً",
  //       en: "Chat For Nutrition Strategy - FREE"
  //     },
];
export const LOGIN_NAV_LINKS = [{ label: "طلباتي", to: "/orders" }];

export const SUGGESTIONS = ["بروتين", "فيتامينات", "كرياتين", "أوميغا 3"];
